class StyleManager {
    getStyle(el, styleProp) {
        let value, defaultView = (el.ownerDocument || document).defaultView;
        // W3C 표준 방법:
        if (defaultView && defaultView.getComputedStyle) {
            // sanitize property name to css notation
            // (hypen separated words eg. font-Size)
            styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
            return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
        }
        // 인터넷 익스플로러 핵
        else if (el.currentStyle) {
            // 프로퍼티 이름을 카멜케이스로 새니타이즈
            styleProp = styleProp.replace(/-(\w)/g, function (str, letter) {
                return letter.toUpperCase();
            });
            value = el.currentStyle[styleProp];
            // 인터넷 익스플로러의 단위를 px 로 변경
            if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
                return (function (value) {
                    const oldLeft = el.style.left, oldRsLeft = el.runtimeStyle.left;
                    el.runtimeStyle.left = el.currentStyle.left;
                    el.style.left = value || 0;
                    value = el.style.pixelLeft + "px";
                    el.style.left = oldLeft;
                    el.runtimeStyle.left = oldRsLeft;
                    return value;
                })(value);
            }
            return value;
        }
    }

    autoGrow(el) {
        if (!el) return;
        const lineHeight = styleManager.getStyle(el, "line-height");
        const matched = lineHeight.match(/\d+/);
        if (!matched) return;
        const number = matched[0];
        const unit = lineHeight.replace(number, "");

        el.style.cssText = 'height:auto; padding:0';
        let scrollHeight = el.scrollHeight;

        // textarea 의 height 가 line-height 보다 작다면
        // line-height 를 textarea의 height 로 한다.(최소 1줄 보장)
        if (Number(number) > Number(scrollHeight)) {
            el.style.cssText = 'height:' + number + "px";
        } else {
            scrollHeight = Math.floor(scrollHeight / number) * number;
            el.style.cssText = 'height:' + scrollHeight + 'px';
        }
    }
}

const styleManager = new StyleManager();

export default styleManager;